export const GET_ALL_FACTUREAVOIR_REQUEST = "GET_ALL_FACTUREAVOIR_REQUEST";
export const GET_ALL_FACTUREAVOIR_SUCCESS = "GET_ALL_FACTUREAVOIR_SUCCESS";
export const GET_ALL_FACTUREAVOIR_FAIL = "GET_ALL_FACTUREAVOIR_FAIL";

export const GET_FACTUREAVOIR_REQUEST = "GET_FACTUREAVOIR_REQUEST";
export const GET_FACTUREAVOIR_SUCCESS = "GET_FACTUREAVOIR_SUCCESS";
export const GET_FACTUREAVOIR_FAIL = "GET_FACTUREAVOIR_FAIL";

export const ADD_FACTUREAVOIR_REQUEST = "ADD_FACTUREAVOIR_REQUEST";
export const ADD_FACTUREAVOIR_SUCCESS = "ADD_FACTUREAVOIR_SUCCESS";
export const ADD_FACTUREAVOIR_FAIL = "ADD_FACTUREAVOIR_FAIL";

export const UPDATE_FACTUREAVOIR_REQUEST = "UPDATE_FACTUREAVOIR_REQUEST";
export const UPDATE_FACTUREAVOIR_SUCCESS = "UPDATE_FACTUREAVOIR_SUCCESS";
export const UPDATE_FACTUREAVOIR_FAIL = "UPDATE_FACTUREAVOIR_FAIL";

export const DELETE_FACTUREAVOIR_REQUEST = "DELETE_FACTUREAVOIR_REQUEST";
export const DELETE_FACTUREAVOIR_SUCCESS = "DELETE_FACTUREAVOIR_SUCCESS";
export const DELETE_FACTUREAVOIR_FAIL = "DELETE_FACTUREAVOIR_FAIL";

export const ADD_FATCAVARTICLE_REQUEST = "ADD_FATCAVARTICLE_REQUEST";
export const ADD_FATCAVARTICLE_SUCCESS = "ADD_FATCAVARTICLE_SUCCESS";
export const ADD_FATCAVARTICLE_FAIL = "ADD_FATCAVARTICLE_FAIL";

export const UPDATE_FATCAVARTICLE_REQUEST = "UPDATE_FATCAVARTICLE_REQUEST";
export const UPDATE_FATCAVARTICLE_SUCCESS = "UPDATE_FATCAVARTICLE_SUCCESS";
export const UPDATE_FATCAVARTICLE_FAIL = "UPDATE_FATCAVARTICLE_FAIL";

export const DELETE_FATCAVARTICLE_REQUEST = "DELETE_FATCAVARTICLE_REQUEST";
export const DELETE_FATCAVARTICLE_SUCCESS = "DELETE_FATCAVARTICLE_SUCCESS";
export const DELETE_FATCAVARTICLE_FAIL = "DELETE_FATCAVARTICLE_FAIL";
